/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: Cognos Dashboard
 *
 * Copyright IBM Corp. 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'./internal/MessageComponent',
	'../../nls/StringResources',
	'react',
	'react-dom'
], function(View, MessageComponent, StringResources, React, ReactDOM) {

	/**
	 * This class renders a message dialog with a single ok button.
	 */
	class MessageDialog extends View {

		/**
		 * prop-types are defined in: {@link MessageComponent}
		 */
		constructor(options) {
			super(options);

			this.size = options.size;
			this.type = options.type;
			this.title = options.title;
			this.message = options.message;
			this.onCloseCallback = options.onCloseCallback;
			this.reactDomNode = this.$el[0];
		}

		render() {
			ReactDOM.render(
				<MessageComponent
					size={this.size}
					className={this.type}
					title={this.title}
					okLabel={StringResources.get('dlg_ok')}
					message={this.message}
					onClose={this._onClose.bind(this)}
				/>,
				this.reactDomNode
			);
		}

		_onClose() {
			this.onCloseCallback && this.onCloseCallback();
			this._close();
		}

		_close() {
			if (this.reactDomNode) {
				ReactDOM.unmountComponentAtNode(this.reactDomNode);
			}
			if (this.$el) {
				this.$el.remove();
				this.$el = null;
			}
			super.remove();
		}
	}

	return MessageDialog;
});
